import React from 'react';
import css from './PillsTabs.module.scss';
import PropTypes from 'prop-types';

const PillsTabs = ({
  children,
  className,
  style,
  fullWidth = false,
}) => {
  return (
    <div
      className={`${css.pillsTabsWrapper} ${fullWidth ? css.fullWidth : ''} ${className || ''}`}
      style={style}
    >
      <div className={css.pillsTabs}>
        {children}
      </div>
    </div>
  );
};

PillsTabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool
};

export default PillsTabs;
